// extracted by mini-css-extract-plugin
export var buttonContainer = "_96-1";
export var fontSizeSelect = "_96-3";
export var formatSelect = "_96-2";
export var formats = "_96-4";
export var hidden = "_96-5";
export var icon = "_96-6";
export var select = "_96-0";